<template>
  <div class="industry-provenance-page">
    <section class="panel">
      <header class="panel__header">
        <h3>产业介绍</h3>
      </header>
      <el-table :data="industryTableData" border class="custom-table">
        <el-table-column
          label="种植面积（亩）"
          min-width="160"
          prop="plantingArea"
        />
        <el-table-column
          label="年度总产量（万斤）"
          min-width="130"
          prop="annualOutput"
        />
        <el-table-column
          label="亩均增收（元/亩）"
          min-width="140"
          prop="avgIncomePerMu"
        />
        <el-table-column
          label="带动就业（人）"
          min-width="140"
          prop="employmentCount"
        />
        <el-table-column label="产业介绍性文字" min-width="220">
          <template slot-scope="scope">
            <span class="ellipsis-text">{{
              scope.row.industryDescription || "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updateTime" min-width="160" />
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleIndustryView(scope.row)"
              >查看</el-button
            >
            <el-button type="text" @click="handleIndustryEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>

    <section class="panel">
      <header class="panel__header">
        <h3>种源介绍</h3>
      </header>
      <el-table :data="provenanceTableData" border class="custom-table">
        <el-table-column label="品种介绍文字" min-width="220">
          <template slot-scope="scope">
            <span class="ellipsis-text">{{
              scope.row.seedDescription || "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="种源图片" min-width="260">
          <template slot-scope="scope">
            <div
              class="image-group"
              v-if="scope.row.imageUrl && scope.row.imageUrl.length"
            >
              <el-image
                v-for="(img, index) in scope.row.imageUrl"
                :key="index"
                :src="getImageUrl(img)"
                fit="cover"
                class="thumb"
                :preview-src-list="(scope.row.imageUrl || []).map(getImageUrl)"
              />
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updateTime" min-width="160" />
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleProvenanceView(scope.row)"
              >查看</el-button
            >
            <el-button type="text" @click="handleProvenanceEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!-- 产业介绍查看/编辑 -->
    <el-dialog
      :title="isIndustryViewMode ? '产业介绍详情' : '产业介绍'"
      :visible.sync="industryEditVisible"
      width="520px"
      @close="resetIndustryForm"
    >
      <el-form
        :model="industryForm"
        ref="industryFormRef"
        label-width="140px"
        :rules="industryRules"
      >
        <el-form-item label="种植面积（亩）" prop="plantingArea">
          <el-input
            v-model="industryForm.plantingArea"
            placeholder="请输入数值"
            clearable
            :disabled="isIndustryViewMode"
          />
        </el-form-item>
        <el-form-item label="年度总产量（万斤）" prop="annualOutput">
          <el-input
            v-model="industryForm.annualOutput"
            placeholder="请输入数值"
            clearable
            :disabled="isIndustryViewMode"
          />
        </el-form-item>
        <el-form-item label="亩均增收（元/亩）" prop="avgIncomePerMu">
          <el-input
            v-model="industryForm.avgIncomePerMu"
            placeholder="请输入数值"
            clearable
            :disabled="isIndustryViewMode"
          />
        </el-form-item>
        <el-form-item label="带动就业（人）" prop="employmentCount">
          <el-input
            v-model="industryForm.employmentCount"
            placeholder="请输入数值"
            clearable
            :disabled="isIndustryViewMode"
          />
        </el-form-item>
        <el-form-item label="产业介绍性文字">
          <el-input
            v-model="industryForm.industryDescription"
            type="textarea"
            :rows="4"
            maxlength="170"
            show-word-limit
            placeholder="请输入内容，不可多于170个字符"
            :disabled="isIndustryViewMode"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="industryEditVisible = false">{{
          isIndustryViewMode ? "关闭" : "取消"
        }}</el-button>
        <el-button
          v-if="!isIndustryViewMode"
          type="primary"
          :loading="industrySubmitting"
          @click="submitIndustryForm"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!-- 种源介绍查看/编辑 -->
    <el-dialog
      :title="isProvenanceViewMode ? '种源介绍详情' : '种源介绍'"
      :visible.sync="provenanceEditVisible"
      width="520px"
      @close="resetProvenanceForm"
    >
      <el-form :model="provenanceForm" label-width="140px">
        <el-form-item label="品种介绍文字">
          <el-input
            v-model="provenanceForm.description"
            type="textarea"
            :rows="4"
            maxlength="170"
            show-word-limit
            placeholder="请输入内容，不可多于170个字符"
            :disabled="isProvenanceViewMode"
          />
        </el-form-item>
        <el-form-item label="种源图片">
          <template v-if="isProvenanceViewMode">
            <div
              class="image-group"
              v-if="provenanceForm.images && provenanceForm.images.length"
            >
              <el-image
                v-for="(img, index) in provenanceForm.images"
                :key="index"
                :src="getImageUrl(img)"
                fit="cover"
                class="thumb-preview"
                :preview-src-list="provenanceForm.images.map(getImageUrl)"
              />
            </div>
            <span v-else class="empty-text">暂无图片</span>
          </template>
          <template v-else>
            <div class="upload-tip">支持 png、jpg，最多可上传4张</div>
            <ImageUpload
              v-model="provenanceForm.images"
              :maxCount="4"
              accept=".png,.jpg,.jpeg"
              @uploading="handleSeedUploading"
            />
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="provenanceEditVisible = false"
          :disabled="provenanceSubmitting && !isProvenanceViewMode"
          >{{ isProvenanceViewMode ? "关闭" : "取消" }}</el-button
        >
        <el-button
          v-if="!isProvenanceViewMode"
          type="primary"
          :loading="provenanceSubmitting"
          :disabled="seedUploading"
          @click="submitProvenanceForm"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  editIndustry,
  getIndustryDetail,
  getIndustryIntroduction,
} from "@/api/industry";
import {
  editSeedSource,
  getSeedSourceDetail,
  getSeedSourceIntroduction,
} from "@/api/seedSource";
import ImageUpload from "@/components/ImageUpload.vue";
import { baseUrl } from "@/axios/baseUrl";
export default {
  name: "IndustryAndProvenance",
  components: {
    ImageUpload,
  },
  data() {
    const parsedIndustryId = Number(this.$route?.query?.industryId);
    const parsedSeedId = Number(this.$route?.query?.seedId);
    return {
      industryDetailId: Number.isNaN(parsedIndustryId) ? 1 : parsedIndustryId,
      seedDetailId: Number.isNaN(parsedSeedId) ? 1 : parsedSeedId,
      industryTableData: [],
      provenanceTableData: [],
      industryDetail: null,
      seedDetail: null,
      activeIndustry: null,
      activeProvenance: null,
      isIndustryViewMode: false,
      industryEditVisible: false,
      isProvenanceViewMode: false,
      provenanceEditVisible: false,
      industrySubmitting: false,
      provenanceSubmitting: false,
      seedUploading: false,
      industryForm: {
        plantingArea: "",
        annualOutput: "",
        avgIncomePerMu: "",
        employmentCount: "",
        industryDescription: "",
      },

      provenanceForm: {
        description: "",
        images: [],
      },
    };
  },
  created() {
    this.fetchDefaultIndustryAndSeedSource();
  },
  computed: {
    industryRules() {
      const numberValidator = (rule, value, callback) => {
        if (value === "" || value === null || value === undefined) {
          callback();
        } else if (!/^-?\d+(\.\d+)?$/.test(value)) {
          callback(new Error("请输入数字"));
        } else {
          callback();
        }
      };
      return {
        plantingArea: [{ validator: numberValidator, trigger: "blur" }],
        annualOutput: [{ validator: numberValidator, trigger: "blur" }],
        avgIncomePerMu: [{ validator: numberValidator, trigger: "blur" }],
        employmentCount: [{ validator: numberValidator, trigger: "blur" }],
      };
    },
  },
  methods: {
    getImageUrl(url) {
      if (!url) return "";
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      return baseUrl + url;
    },
    // 获取默认种源介绍和产业介绍
    async fetchDefaultIndustryAndSeedSource() {
      try {
        const industryRes = await getIndustryIntroduction();
        const seedSourceRes = await getSeedSourceIntroduction();

        this.industryTableData = industryRes.data ? [industryRes.data] : [];
        this.provenanceTableData = seedSourceRes.data
          ? [seedSourceRes.data]
          : [];
      } catch (error) {
        console.error("获取默认种源介绍和产业介绍失败", error);
      }
    },
    normalizeIndustryDetail(detail = {}) {
      if (!detail || typeof detail !== "object") {
        return null;
      }
      return {
        id: detail.id,
        plantingArea: detail.plantingArea ?? "",
        annualOutput: detail.annualOutput ?? "",
        avgIncomePerMu: detail.avgIncomePerMu ?? "",
        employmentCount: detail.employmentCount ?? "",
        industryDescription: detail.industryDescription ?? "",
        updateTime: detail.updateTime ?? "",
      };
    },
    handleIndustryView(row) {
      if (!row) {
        this.$message.warning("暂无可查看的内容");
        return;
      }
      this.activeIndustry = { ...row };
      this.isIndustryViewMode = true;
      Object.assign(this.industryForm, {
        plantingArea: row.plantingArea || "",
        annualOutput: row.annualOutput || "",
        avgIncomePerMu: row.avgIncomePerMu || "",
        employmentCount: row.employmentCount || "",
        industryDescription: row.industryDescription || "",
      });
      this.industryEditVisible = true;
    },
    handleIndustryEdit(row) {
      const targetRow =
        row && Object.keys(row || {}).length ? row : this.industryDetail;
      if (!targetRow) {
        this.$message.warning("暂无可编辑的内容");
        return;
      }
      this.activeIndustry = { ...targetRow };
      this.isIndustryViewMode = false;
      Object.assign(this.industryForm, {
        plantingArea: targetRow.plantingArea || "",
        annualOutput: targetRow.annualOutput || "",
        avgIncomePerMu: targetRow.avgIncomePerMu || "",
        employmentCount: targetRow.employmentCount || "",
        industryDescription: targetRow.industryDescription || "",
      });
      this.industryEditVisible = true;
    },
    submitIndustryForm() {
      this.$refs.industryFormRef.validate(async (valid) => {
        if (!valid) return;
        this.industrySubmitting = true;
        try {
          const payload = this.buildIndustryPayload();
          await editIndustry(payload);
          this.$message.success("已保存产业介绍内容");
          this.industryEditVisible = false;
          await this.fetchDefaultIndustryAndSeedSource();
        } catch (error) {
          console.error("保存产业介绍失败", error);
        } finally {
          this.industrySubmitting = false;
        }
      });
    },
    buildIndustryPayload() {
      const parseNumber = (value) => {
        if (value === "" || value === null || value === undefined) {
          return undefined;
        }
        const num = Number(value);
        return Number.isNaN(num) ? undefined : num;
      };
      return {
        id: this.activeIndustry?.id ?? this.industryDetailId,
        plantingArea: parseNumber(this.industryForm.plantingArea),
        annualOutput: parseNumber(this.industryForm.annualOutput),
        avgIncomePerMu: parseNumber(this.industryForm.avgIncomePerMu),
        employmentCount: parseNumber(this.industryForm.employmentCount),
        industryDescription: this.industryForm.industryDescription,
      };
    },
    resetIndustryForm() {
      if (this.$refs.industryFormRef) {
        this.$refs.industryFormRef.resetFields();
      }
      Object.assign(this.industryForm, {
        plantingArea: "",
        annualOutput: "",
        avgIncomePerMu: "",
        employmentCount: "",
        industryDescription: "",
      });
    },
    async fetchSeedSourceDetail() {
      const targetId = this.seedDetailId;
      if (
        targetId === undefined ||
        targetId === null ||
        Number.isNaN(targetId)
      ) {
        return;
      }
      try {
        const res = await getSeedSourceDetail(targetId);
        const detail = this.normalizeSeedDetail(res?.data);
        this.seedDetail = detail;
        if (detail && detail.id !== undefined) {
          this.seedDetailId = detail.id;
        }
      } catch (error) {
        console.error("获取种源介绍详情失败", error);
      }
    },
    async fetchIndustryDetail() {
      const targetId = this.industryDetailId;
      if (
        targetId === undefined ||
        targetId === null ||
        Number.isNaN(targetId)
      ) {
        return;
      }
      try {
        const res = await getIndustryDetail(targetId);
        const detail = this.normalizeIndustryDetail(res?.data);
        this.industryDetail = detail;
        if (detail && detail.id !== undefined) {
          this.industryDetailId = detail.id;
        }
      } catch (error) {
        console.error("获取产业介绍详情失败", error);
      }
    },
    normalizeSeedDetail(detail = {}) {
      if (!detail || typeof detail !== "object") {
        return null;
      }
      return {
        id: detail.id,
        description: detail.seedDescription ?? "",
        images: this.extractImageUrls(detail.imageUrl),
        rawImageList: Array.isArray(detail.imageUrl) ? detail.imageUrl : [],
        updateTime: detail.updateTime ?? "",
      };
    },
    extractImageUrls(imageList) {
      if (!Array.isArray(imageList)) {
        return [];
      }
      return imageList
        .map((item) => {
          if (!item) return "";
          if (typeof item === "string") return item;
          if (typeof item === "object") {
            return item.url || item.imageUrl || item.path || "";
          }
          return "";
        })
        .filter(Boolean);
    },
    async handleProvenanceView(row) {
      if (!row || !row.id) {
        this.$message.warning("暂无可查看的种源介绍内容");
        return;
      }
      try {
        const res = await getSeedSourceDetail(row.id);
        const detail = this.normalizeSeedDetail(res?.data);
        if (!detail) {
          this.$message.warning("获取种源介绍详情失败");
          return;
        }
        this.activeProvenance = { ...detail };
        this.isProvenanceViewMode = true;
        Object.assign(this.provenanceForm, {
          description: detail.description || "",
          images: detail.images ? [...detail.images] : [],
        });
        this.provenanceEditVisible = true;
      } catch (error) {
        console.error("获取种源介绍详情失败", error);
        this.$message.error("获取详情失败，请重试");
      }
    },
    async handleProvenanceEdit(row) {
      if (!row || !row.id) {
        this.$message.warning("暂无可编辑的种源介绍内容");
        return;
      }
      try {
        const res = await getSeedSourceDetail(row.id);
        const detail = this.normalizeSeedDetail(res?.data);
        if (!detail) {
          this.$message.warning("获取种源介绍详情失败");
          return;
        }
        this.activeProvenance = { ...detail };
        this.isProvenanceViewMode = false;
        Object.assign(this.provenanceForm, {
          description: detail.description || "",
          images: detail.images ? [...detail.images] : [],
        });
        this.provenanceEditVisible = true;
      } catch (error) {
        console.error("获取种源介绍详情失败", error);
        this.$message.error("获取详情失败，请重试");
      }
    },
    handleSeedUploading(uploading) {
      this.seedUploading = uploading;
    },
    async submitProvenanceForm() {
      if (this.seedUploading) {
        this.$message.warning("图片正在上传，请稍候");
        return;
      }
      this.provenanceSubmitting = true;
      try {
        const payload = this.buildSeedPayload();
        await editSeedSource(payload);
        this.$message.success("已保存种源介绍内容");
        this.provenanceEditVisible = false;
        await this.fetchDefaultIndustryAndSeedSource();
      } catch (error) {
        console.error("保存种源介绍失败", error);
      } finally {
        this.provenanceSubmitting = false;
      }
    },
    buildSeedPayload() {
      const normalizeImagePayload = (images = []) => {
        if (!Array.isArray(images)) return [];
        return images
          .map((item) => {
            if (!item) return "";
            if (typeof item === "string") {
              return item;
            }
            if (typeof item === "object") {
              return item.url || item.imageUrl || item.path || "";
            }
            return "";
          })
          .filter(Boolean);
      };
      return {
        id: this.activeProvenance?.id ?? this.seedDetailId,
        seedDescription: this.provenanceForm.description,
        imageUrl: normalizeImagePayload(this.provenanceForm.images),
      };
    },
    resetProvenanceForm() {
      Object.assign(this.provenanceForm, {
        description: "",
        images: [],
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-descriptions__body {
  background-color: rgba(0, 11, 47, 0.5) !important;
}
/deep/.el-descriptions--mini.is-bordered .el-descriptions-item__cell {
  background-color: rgba(0, 11, 47, 0.5) !important;
}
.industry-provenance-page {
  padding: 20px;
  background-color: #0b0e1a;
  color: #e1e5ef;

  .panel {
    margin-bottom: 24px;
    background: #04060f;
    border: 1px solid #2b2f44;
    border-radius: 6px;
    padding: 16px;

    &__header {
      border-bottom: 1px solid #1d2336;
      margin-bottom: 16px;

      h3 {
        color: #fff;
        font-size: 18px;
        margin: 0 0 8px;
      }
    }
  }
}

.custom-table {
  background: transparent;

  th {
    background: rgba(28, 33, 53, 0.9);
    color: #8fb1ff;
  }

  td {
    background: rgba(8, 11, 23, 0.9);
    color: #e9ecf7;
  }
}

.ellipsis-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-group {
  display: flex;
  gap: 8px;

  .thumb {
    width: 80px;
    height: 60px;
    border-radius: 4px;
    border: 1px solid #2f3650;
  }
}

.dialog-label {
  font-weight: 600;
  margin: 12px 0 4px;
}

.dialog-text {
  line-height: 1.6;
}

.upload-tip {
  color: #f56c6c;
  margin-bottom: 8px;
}

.thumb-preview {
  width: 100px;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #2f3650;
  object-fit: cover;
  cursor: pointer;
}

.empty-text {
  color: #909399;
  font-size: 14px;
}
</style>
